import { IconChevronLeft12, IconChevronRight12 } from '@cian/ui-kit';
import * as React from 'react';
import { Settings } from 'react-slick';

const SLIDES_TO_SHOW = 5;

export const useCarouselSettings = (itemsCount: number): Settings => {
  const infinite = itemsCount > SLIDES_TO_SHOW;

  return React.useMemo(
    () => ({
      dots: false,
      infinite,
      autoplay: false,
      slidesToShow: SLIDES_TO_SHOW,
      slidesToScroll: SLIDES_TO_SHOW,
      adaptiveHeight: true,
      nextArrow: (
        <button title="Вперед">
          <IconChevronRight12 />
        </button>
      ),
      prevArrow: (
        <button title="Назад">
          <IconChevronLeft12 />
        </button>
      ),
    }),
    [infinite],
  );
};
